import IngredientCrud from './IngredientCrud'
export {IngredientCrud}
export default IngredientCrud
